import styled from 'styled-components';
import { Title } from '../../../../components/v2/Header';

const StyledTitle = styled(Title)`
  text-transform: uppercase;
  font-size: 15px;
  margin-bottom: 0;
`;

export {
  StyledTitle,
};
